import { useNavigate } from '@tanstack/react-router';
import { useCallback } from 'react';
import useAppStore from '../store/rootStore';

export function useMarketNavigation() {
  const navigate = useNavigate();

  const navigateToMarket = useCallback(
    (marketId: number) => {
      const markets = useAppStore.getState().markets;
      const selected = markets.get(marketId);
      if (selected?.symbol) {
        navigate({ to: '/trade/$marketSymbol', params: { marketSymbol: selected.symbol } });
      }
    },
    [navigate]
  );

  return navigateToMarket;
}
